// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"77ed7188","498":"3d8f179b"}[chunkId] + ".chunk.css";
};